import { I18n } from 'aws-amplify'
import { useSelector } from 'react-redux'
import { DICTIONARY } from '../constants/text'

const useInternationalization = () => {
    const building = useSelector((state) => state.app.building)

    I18n.putVocabularies(DICTIONARY)

    if (Object.keys(building).length !== 0 && building.address.city === 'Houston') {
        I18n.setLanguage('houston')
    }
}

export { useInternationalization }
